import styled from '@emotion/styled';

/**
 * Текст заголовка над блоком радио-кнопок.
 */
export const Text = styled.div`
  font-size: 0.875rem;
`;
